<h1 mat-dialog-title>{{ getLabel('titleLabel') }}</h1>

<div mat-dialog-content>

  <p>
    {{ getLabel('textLabel')}}
  </p>

  <div *ngIf="checkComponent('checkAndChangePaymentMethod')" style="background-color: #fff3cd; padding: 15px; border-radius: 4px; border-left: 4px solid #ffc107; margin-bottom: 15px;">
    <p style="margin-bottom: 10px;">
      <strong>{{ "CHANGESTATEBUTTON.change_payment_method_warning" | translate }}</strong>
    </p>
    <p style="margin-bottom: 10px;">
      {{ "CHANGESTATEBUTTON.change_payment_method_current" | translate }}: <strong>{{ paymentMethod?.label }}</strong>
    </p>
    <div *ngIf="paymentMethod?.paymentMethodSteps?.length > 0" style="margin-top: 10px;">
      <p style="margin-bottom: 5px; font-weight: 500;">{{ "CHANGESTATEBUTTON.change_payment_method_steps" | translate }}:</p>
      <ul style="margin: 0; padding-left: 20px;">
        <li *ngFor="let step of paymentMethod.paymentMethodSteps; let i = index">
          Step {{ i + 1 }}: {{ step.label || ('Step ' + (i + 1)) }}
        </li>
      </ul>
    </div>
  </div>

  <form *ngIf="formIsActive" [formGroup]="form" class="form-container">

    <mat-radio-group *ngIf="actions.length > 0" aria-labelledby="example-radio-group--label" class="example-radio-group"
      formControlName="esit">
      <mat-radio-button color="primary" class="example-radio-button" *ngFor="let action of actions" [value]="action">
        {{ "CLOSEREQUEST." + action | translate }}
      </mat-radio-button>
    </mat-radio-group>

    <mat-form-field *ngIf="estimateDeliveryMethods" style="width: 100%;" appearance="fill" class="form-activities">
      <mat-label>{{ 'ESTIMATEDELIVERYMETHOD.metodo_di_consegna_al_cliente' | translate }}</mat-label>
      <mat-select matNativeControl formControlName="EstimateDeliveryMethodId">
        <mat-option *ngFor="let estimateDeliveryMethod of estimateDeliveryMethods"
          [value]="''+estimateDeliveryMethod.id">
          <!-- | async -->
          {{ "ESTIMATEDELIVERYMETHOD."+ estimateDeliveryMethod.code | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="listOfStatesAvailableForMigration?.length > 0" style="width: 100%;" appearance="fill" class="form-activities">
      <mat-label>{{ 'LABEL.STATE' | translate }}</mat-label>
      <mat-select matNativeControl formControlName="migrationState">
        <mat-option *ngFor="let state of listOfStatesAvailableForMigration" [disabled]="state.disabled" [value]="state.id">
          <!-- | async -->
          {{ state.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="reasons" style="width: 100%;" appearance="fill" class="form-activities">
      <mat-label>{{ 'REASONS.title' | translate }}</mat-label>
      <mat-select matNativeControl formControlName="ReasonCode" (selectionChange)="onChangeReasonsSelect($event)">
        <mat-option *ngFor="let reason of reasons" [value]="''+reason.code">
          <!-- | async -->
          {{ "REASONS."+ reason.code | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <p *ngIf="reasons">{{ "REASONS.reasonNextStateAlert" | translate }}: <strong>{{getReasonAlert()}}</strong></p>

    <p *ngIf="currentSignalers">{{ "LABEL.selectSignalerText" | translate }}</p>
    <mat-form-field *ngIf="currentSignalers" style="width: 100%;" appearance="fill" class="form-activities">
      <mat-label>{{ 'LABEL.signaler' | translate }}</mat-label>
      <mat-select matNativeControl formControlName="currentSignaler">
        <mat-option *ngFor="let signaler of currentSignalers" [value]="signaler">
          {{ signaler.fullname}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="requiresNotesField" class="example-full-width">
      <mat-label>Note</mat-label>
      <textarea matInput rows="5" formControlName="notes" placeholder="Note"></textarea>
    </mat-form-field>

  </form>

</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="form.value" [disabled]="disabledConfirmButton()">{{ confirmButtonLabel |
    translate }}</button>
  <button mat-button [mat-dialog-close]="">{{ cancelButtonLabel | translate }}</button>
</div>